var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"height":"100%","width":"100%"}},[(_vm.$checkEmpty(_vm.info))?_c('div',{staticClass:"flex-center sub-video-none"}):(_vm.$checkEmpty(_vm.info.rtsp))?_c('div',{staticClass:"flex-center sub-video-noauth"},[_vm._v("暂无RTSP")]):_c('video',{attrs:{"id":_vm.vEleId,"autoplay":"","controls":_vm.controlsFlag}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e586f4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubVideo/SubVideoRTSP.vue
// module id = null
// module chunks = 